import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Share2, Clock, CheckCircle, XCircle } from 'lucide-react';

const ReferralManagement: React.FC = () => {
  const [referrals, setReferrals] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const response = await api.get('/referrals/my');
        setReferrals(response.data);
      } catch (error) {
        console.error('Error fetching referrals:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchReferrals();
  }, []);

  if (loading) return <div>Loading referrals...</div>;

  return (
    <div style={{ padding: '1rem' }}>
      <h3 style={{ fontSize: '1.25rem', marginBottom: '1.5rem', color: '#1a365d' }}>My Referrals</h3>
      
      <div style={{ display: 'grid', gap: '1rem' }}>
        {referrals.map((ref) => (
          <div key={ref.id} style={{ padding: '1.5rem', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                <span style={{ fontWeight: 'bold', color: '#1a365d' }}>{ref.case?.caseId || 'N/A'}</span>
                <span style={{ padding: '0.2rem 0.6rem', fontSize: '0.7rem', borderRadius: '9999px', backgroundColor: getStatusColor(ref.status).bg, color: getStatusColor(ref.status).text, fontWeight: 'bold', textTransform: 'uppercase' }}>
                  {ref.status}
                </span>
              </div>
              <h4 style={{ fontSize: '1.1rem', marginBottom: '0.25rem' }}>{ref.case?.title || 'Case Title'}</h4>
              <p style={{ color: '#718096', fontSize: '0.875rem' }}>Commission Rate: {ref.commissionRate * 100}% • Earned: PKR {ref.commissionAmount}</p>
            </div>
            
            <div>
              {ref.status === 'pending' && <Clock size={20} color="#d69e2e" />}
              {ref.status === 'approved' && <CheckCircle size={20} color="#38a169" />}
              {ref.status === 'rejected' && <XCircle size={20} color="#e53e3e" />}
            </div>
          </div>
        ))}
        {referrals.length === 0 && (
          <div style={{ textAlign: 'center', padding: '3rem', backgroundColor: '#f8fafc', borderRadius: '8px', border: '2px dashed #e2e8f0' }}>
            <p style={{ color: '#718096' }}>You haven't referred any cases yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

const getStatusColor = (status: string) => {
  switch (status) {
    case 'pending': return { bg: '#fffaf0', text: '#9c4221' };
    case 'approved': return { bg: '#f0fff4', text: '#276749' };
    case 'completed': return { bg: '#ebf8ff', text: '#2b6cb0' };
    case 'rejected': return { bg: '#fff5f5', text: '#c53030' };
    default: return { bg: '#edf2f7', text: '#4a5568' };
  }
};

export default ReferralManagement;
